import DropdownPrimary from './DropdownPrimary';
import './DropdownPrimary.scss';

export default DropdownPrimary;
